module.exports = __webpack_public_path__ + "static/taapi2-3a14e6dcfd9abf9227a74988b82b433f.png";